<template>
  <v-container :dark="$store.getters.getColorPalette().isDark" fluid>
    <InfoAlert
      :showDismissibleAlert="showDismissibleAlert"
      v-on:close="showDismissibleAlert = false"
      :info="info"
    />

    <!-- widget title -->

    <v-card
      :dark="$store.getters.getColorPalette().isDark"
      :style="{
        border:
          '1px solid ' + $store.getters.getColorPalette().panelBorderColorCode,
        'background-color':
          $store.getters.getColorPalette().background2ColorCode,
      }"
      flat
      outlined
      class="px-3 pb-5"
    >
      <v-card-title v-if="edit" class="sub-heading">{{
        $store.getters.getTextMap().edit_shift_based_bar_trend_widget
      }}</v-card-title>

      <v-card-title v-else class="sub-heading">{{
        $store.getters.getTextMap().add_shift_based_bar_trend_widget
      }}</v-card-title>

      <!-- Widget Form -->
      <h3 class="mx-3 pb-2">
        {{ $store.getters.getTextMap().widget_details }} :
      </h3>
      <v-form
        :dark="$store.getters.getColorPalette().isDark"
        ref="widgetForm"
        v-model="widgetValid"
      >
        <!-- Widget Details Starts Here -->
        <v-row>
          <!-- Widget label input field -->
          <v-col align-self="center">
            <v-skeleton-loader
              v-if="loading"
              class="mx-auto"
              type="text"
            ></v-skeleton-loader>
            <v-text-field
              dense
              outlined
              v-if="!loading"
              v-model="widgetForm.label"
              :counter="30"
              :rules="[rules.required]"
              :label="$store.getters.getTextMap().widget_label"
              required
            ></v-text-field>
          </v-col>

          <!-- Widget width -->
          <v-col align-self="center">
            <v-select
              :dark="$store.getters.getColorPalette().isDark"
              :color="$store.getters.getColorPalette().inputtextColor"
              :menu-props="{ dark: $store.getters.getColorPalette().isDark }"
              v-if="!loading"
              v-model="widgetForm.width"
              :items="widthOptions"
              :label="$store.getters.getTextMap().widget_width"
              dense
              outlined
              item-text="label"
              item-value="value"
            ></v-select>
          </v-col>
          <!-- Widget height -->
          <v-col>
            <v-select
              v-if="!loading"
              v-model="widgetForm.height"
              :items="heightOptions"
              :label="$store.getters.getTextMap().widget_height"
              dense
              outlined
              item-text="label"
              item-value="value"
              :menu-props="{ dark: $store.getters.getColorPalette().isDark }"
            ></v-select>
          </v-col>
        </v-row>

        <v-row>
          <!-- Background color -->
          <v-col>
            <v-select
              v-if="!loading"
              v-model="widgetForm.background_color"
              :items="$store.getters.getBackgroundColorOptions()"
              :label="$store.getters.getTextMap().background_color"
              dense
              outlined
              item-text="label"
              item-value="value"
              clearable
              :menu-props="{ dark: $store.getters.getColorPalette().isDark }"
            >
              <template v-slot:selection="{ item }">
                <div :style="{ 'background-color': item.value }">
                  {{ item.label }}
                </div>
              </template>
              <template v-slot:item="{ item }">
                <div :style="{ 'background-color': item.value }">
                  {{ item.label }}
                </div>
              </template>
            </v-select>
          </v-col>

          <!-- Widget timeframe like rtd, ytd etc.. -->
          <v-col align-self="center">
            <v-select
              :dark="$store.getters.getColorPalette().isDark"
              :color="$store.getters.getColorPalette().inputtextColor"
              :menu-props="{ dark: $store.getters.getColorPalette().isDark }"
              v-if="!loading"
              v-model="timeFrame"
              :items="tdOptions"
              :label="$store.getters.getTextMap().timeFrame"
              dense
              outlined
              item-text="label"
              item-value="value"
            ></v-select>
          </v-col>
          <!-- widget timerange like daily .. -->
          <!-- <v-col align-self="center">
            <v-select
              :dark="$store.getters.getColorPalette().isDark"
              :color="$store.getters.getColorPalette().inputtextColor"
              :menu-props="{ dark: $store.getters.getColorPalette().isDark }"
              v-if="!loading"
              v-model="timeRange"
              :items="trOptions"
              :label="$store.getters.getTextMap().aggregation"
              dense
              outlined
              item-text="label"
              item-value="value"
            ></v-select>
          </v-col> -->
        </v-row>

        <v-row>
          <!--default Graph mode  -->
          <v-col align-self="center">
            <v-select
              :dark="$store.getters.getColorPalette().isDark"
              :color="$store.getters.getColorPalette().inputtextColor"
              :menu-props="{ dark: $store.getters.getColorPalette().isDark }"
              v-if="!loading"
              v-model="graphType"
              :items="graphTypeOptions"
              :label="$store.getters.getTextMap().default_graph_type"
              dense
              outlined
              item-text="label"
              item-value="value"
            ></v-select>
          </v-col>

          <!--Default Bar mode  -->
          <!-- <v-col v-if="!loading && graphType == 2" align-self="center">
            <v-select
              :dark="$store.getters.getColorPalette().isDark"
              :color="$store.getters.getColorPalette().inputtextColor"
              :menu-props="{ dark: $store.getters.getColorPalette().isDark }"
              v-if="!loading && graphType == 2"
              v-model="barmode"
              :items="barmodeOptions"
              :rules="[rules.required]"
              :label="$store.getters.getTextMap().bar_mode"
              dense
              outlined
              item-text="label"
              item-value="value"
            ></v-select>
          </v-col> -->

          <!-- widget parm seq -->
          <v-col v-if="edit" align-self="center">
            <v-text-field
              v-if="!loading"
              v-model="widgetForm.seq"
              :counter="3"
              :label="$store.getters.getTextMap().sequence"
              dense
              outlined
            ></v-text-field>
          </v-col>

          <!-- x-axis label -->
          <v-col align-self="center">
            <v-text-field
              :dark="$store.getters.getColorPalette().isDark"
              :color="$store.getters.getColorPalette().inputtextColor"
              :menu-props="{ dark: $store.getters.getColorPalette().isDark }"
              v-if="!loading"
              v-model="xaxisLabel"
              :rules="[rules.required]"
              :label="$store.getters.getTextMap().xaxis_label"
              dense
              outlined
              item-text="label"
              item-value="value"
            ></v-text-field>
          </v-col>
          <!-- Y axis label -->
          <v-col align-self="center">
            <v-text-field
              :dark="$store.getters.getColorPalette().isDark"
              :color="$store.getters.getColorPalette().inputtextColor"
              :menu-props="{ dark: $store.getters.getColorPalette().isDark }"
              v-if="!loading"
              :rules="[rules.required]"
              v-model="yaxisLabel"
              :label="$store.getters.getTextMap().yaxis_label"
              dense
              outlined
              item-text="label"
              item-value="value"
            ></v-text-field>
          </v-col>
        </v-row>
        <!-- Widget Details Ends Here -->

        <!-- Parameter Details Starts Here -->
        <h3 class="mx-3 pb-4">
          {{ $store.getters.getTextMap().paramter_details }} :
        </h3>

        <!-- {{edit}} -->

        <v-row>
          <WorkspaceMachineParamForm
            v-if="edit"
            :exsistingParameter="widgetForm.meta.paramsdata.parameter"
            :exsistingWorkspace="widgetForm.meta.paramsdata.workspace"
            :exsistingMachine="widgetForm.meta.paramsdata.machine"
            :multiple="true"
            @value="updateFormWithParam"
          />

          <WorkspaceMachineParamForm
            v-else
            :multiple="true"
            @value="updateFormWithParam"
          />

          <v-col>
            <v-autocomplete
              :dark="$store.getters.getColorPalette().isDark"
              :color="$store.getters.getColorPalette().inputtextColor"
              v-if="!loading"
              v-model="shifts"
              :items="shiftOptions"
              :label="$store.getters.getTextMap().shifts"
              dense
              outlined
              item-text="label"
              item-value="value"
              required
              :rules="[rules.required]"
              :menu-props="{ dark: $store.getters.getColorPalette().isDark }"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col align="left">
            <v-btn
              :dark="$store.getters.getColorPalette().isDark"
              :color="$store.getters.getColorPalette().submitbtnColor"
              small
              filled
              @click="onSubmit"
            >
              {{ $store.getters.getTextMap().submit }}
            </v-btn>
            <v-btn
              style="margin-left: 20px"
              :dark="$store.getters.getColorPalette().isDark"
              :color="$store.getters.getColorPalette().cancelbtnColor"
              small
              @click="onClose"
              >{{ $store.getters.getTextMap().cancel }}</v-btn
            >
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </v-container>
</template>
<script>
import InfoAlert from "@/components/InfoAlert";
import axios from "axios";
import FormRules from "@/utillities/FormRules";
// import DeleteConfirmation from '@/components/DeleteConfirmation'
import WorkspaceMachineParamForm from "@/components/forms/WorkspaceMachineParamForm.vue";

export default {
  name: "AddShiftBasedBarTrendWidget",
  components: {
    InfoAlert,
    WorkspaceMachineParamForm,
    // DeleteConfirmation
  },
  props: ["widget", "seq", "edit"],
  data() {
    return {
      showDismissibleAlert: false,
      info: "",
      loading: false,
      valid: false,
      widgetForm: {
        meta: {},
      },
      rules: FormRules.rules,
      widgetValid: false,
      timeFrame: "",
      // timeRange: "",
      // barmode: "",
      shifts: "",
      graphType: 2,
      widthOptions: [
        { label: "Full screen", value: 12 },
        { label: "Half screen", value: 6 },
        { label: "1/3 screen", value: 4 },
        { label: "Quarter screen", value: 3 },
        { label: "3/4 screen", value: 9 },
        { label: "Auto", value: null },
      ],
      heightOptions: [
        { label: "Fixed", value: "fixed" },
        { label: "Flex", value: "flex" },
      ],
      tdOptions: [
        { label: "Real Time", value: "rtd" },
        { label: "MTD (Month Till Date)", value: "mtd" },
        { label: "YTD (Year Till Date)", value: "ytd" },
        { label: "last 7 days", value: "7" },
        { label: "last 30 days", value: "30" },
        { label: "last 60 days", value: "60" },
        { label: "last 90 days", value: "90" },
        { label: "last 180 days", value: "180" },
        { label: "last 365 days", value: "365" },
      ],
      api: "createWidgetForView",
      trOptions: [
        { label: "Daily", value: "day" },
        { label: "Weekly", value: "week" },
        { label: "Monthly", value: "month" },
        { label: "Yearly", value: "year" },
      ],
      graphTypeOptions: [
        { label: "Bar", value: 2 },
        { label: "Line", value: 1 },
      ],
      // barmodeOptions: [
      //   { label: "Stacked", value: "stack" },
      //   { label: "Grouped", value: "group" },
      // ],
      yaxisLabel: null,
      xaxisLabel: null,
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    shiftOptions() {
      let op = [];
      for (let i of this.$store.state.shifts) {
        op.push({ value: i.shift_id, label: i.name });
      }
      return op;
    },
  },
  methods: {
    init() {
      console.log(this.widget, "widget");

      if (this.widget && this.widget.widget_id && this.widget.view_id) {
        this.edit = true;
        this.api = "updateWidget";
        this.widgetForm = JSON.parse(JSON.stringify(this.widget));
        this.timeFrame = this.widgetForm.meta.timeFrame;
        // this.timeRange = this.widgetForm.meta.timeRange;
        // this.barmode = this.widgetForm.meta.barmode;
        this.graphType = this.widgetForm.meta.graphType;
        this.xaxisLabel = this.widgetForm.meta.xaxisLabel;
        this.yaxisLabel = this.widgetForm.meta.yaxisLabel;
        this.shifts = this.widgetForm.meta.shift_id;
        console.log(this.widgetForm, "widget form");
      } else {
        if (this.widget.view_id) {
          this.api = "createWidgetForView";
          this.widgetForm = Object.assign({}, this.widget);
          this.widgetForm.meta = {};
          this.widgetForm.seq = this.seq ? this.seq : 0;
        }
      }
    },

    updateFormWithParam(value) {
      this.widgetForm.meta.paramsdata = value;
    },
    async onSubmit() {
      this.$refs.widgetForm.validate();
      if (this.widgetValid) {
        this.loading = true;
        this.widgetForm.meta.timeFrame = this.timeFrame;
        // this.widgetForm.meta.timeRange = this.timeRange;
        // this.widgetForm.meta.barmode = this.barmode;
        this.widgetForm.meta.graphType = this.graphType;
        this.widgetForm.meta.xaxisLabel = this.xaxisLabel;
        this.widgetForm.meta.yaxisLabel = this.yaxisLabel;
        this.widgetForm.meta.shift_id = this.shifts;
        // console.log(this.widgetForm, "final widget form");
        const headers = {
          headers: {
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
        };
        try {
          const response = await axios.post(
            this.$store.state.api + this.api,
            this.widgetForm,
            headers
          );
          console.log(response, "add widget response");
          if (response.data.status == "success") {
            this.info = this.edit
              ? "Widget Updated Successfully"
              : "Widget Created Successfully";
            this.showDismissibleAlert = true;
            this.$emit("success");
            this.$emit("close");
          } else {
            this.info = response.data.msg;
            this.showDismissibleAlert = true;
          }
        } catch (error) {
          // console.error("Error adding widget:", error);
          this.info = error;
          this.showDismissibleAlert = true;
        } finally {
          this.loading = false;
        }
      }
    },
    onClose() {
      this.widgetForm.reset();
    },
  },
};
</script>